export enum LightDarkMode {
  LIGHT = 'light',
  DARK = 'dark',
}
